import { fromJS } from 'immutable';

export const LOAD_INIT = 'mbb/LOAD_INIT';
export const LOAD_SUCCESS = 'mbb/LOAD_SUCCESS';
export const LOAD_FAIL = 'mbb/LOAD_FAIL';

const ENDPOINT = '/api/mbb';

const initialState = {
  offers: fromJS([])
};

export default function mbb(state = initialState, { type, payload }) {
  if (type === LOAD_SUCCESS) {
    return {
      ...state,
      offers: fromJS(payload.offers)
    };
  }

  return state;
}

export function getOffers() {
  return {
    types: [LOAD_INIT, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.get(`${ENDPOINT}/`)
  };
}

export function isLoaded({ getState }) {
  return getState().mbb.offers.size;
}

export function serialize(state) {
  return state.offers.toJS();
}

export function deserialize(state) {
  if (state === null) {
    return initialState;
  }
  return {
    offers: fromJS(state)
  };
}
